import { NavLink, Outlet } from "react-router";

const nav = [
  { to: "/", label: "Halftime Replay" },
  { to: "/games", label: "Games" },
];

export function AppShell() {
  return (
    <div className="app">
      <header className="topbar">
        <NavLink to="/" className="brand" aria-label="NFL 2H Model home">
          <div className="brand-mark">2H</div>
          <div>
            <div className="brand-title">NFL 2H Model</div>
            <div className="brand-subtitle">Halftime predictions</div>
          </div>
        </NavLink>

        <nav className="nav" aria-label="Primary navigation">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="main">
        <Outlet />
      </main>

      <footer className="footer">
        Historical replay · 2023–2025
      </footer>
    </div>
  );
}
